module.exports = __webpack_public_path__ + "static/media/WhitePurleHaze.115b588d.jpg";